export default {

    emits: ['update:modelValue'],

    props: {
        modelValue: {default: false}
    },

    data() {
        return {
            isActive: !!this.modelValue,
        }
    },

    watch: {
        modelValue(val) {
            this.isActive = !!val
        },

        isActive(val) {
            if (!!val !== this.modelValue) {
                this.$emit('update:modelValue', val);
            }
        },
    },
}
